import Vue from 'vue';
import ErrorPage from 'vue-error-page';

window.eventBus = new Vue();

Vue.use(ErrorPage, {
  tagName: 'app-view',
  bus: 'eventBus',
  event: 'error-page',
  resolver: component => {
    return require('@shared/pages/errors/' + component).default;
  }
});
